export default __webpack_public_path__ + "static/media/service-bg-mobile.afdf1dec.webp";